import React from 'react';
import PropTypes from 'prop-types';

const Card = (props) => {
  const { isChild, className } = props;
  const compStyle = {};

  if (isChild) {
    compStyle.padding = 0;
  }

  return (
    <div className={[className, isChild ? '' : 'cards'].join(' ')} style={compStyle}>
      {props.children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isChild: PropTypes.bool,
};

Card.defaultProps = {
  className: '',
};

export default Card;
